// native
import { TitleCasePipe } from '@angular/common';
import { Component, Input } from '@angular/core';

// addon
import { TranslateService } from '@ngx-translate/core';

// models
import { CompositeFilterDescriptor } from 'app/models';

// service
import { BaseFilterCellComponent, GridFilterService } from 'app/shared/components/data-grid/grid-filter.service';

@Component({
    selector: 'grid-dropdown-filter',
    template: `
    <mat-select
      class="dg-filter_select"
      [value]="selectedValue"
      (selectionChange)="onChange($event.value)">
      <mat-option [value]="null">{{ defaultItemText }}</mat-option>
      @for (item of data; track item) {
        <mat-option [value]="item[valueField]">
          {{ item[textField] }}
        </mat-option>
      }
    </mat-select>
    `,
    standalone: false
})
export class DropDownListFilterComponent extends BaseFilterCellComponent {
  public get selectedValue(): unknown {
    const filter = this.filterByField(this.valueField);
    return filter ? filter.value : null;
  }

  @Input() public filter: CompositeFilterDescriptor;
  @Input() public data: any[];
  @Input() public column: string;
  @Input() public textField: string;
  @Input() public valueField: string;

  public get defaultItemText(): string {
    return new TitleCasePipe().transform(this.translateService.instant('select')) + '...';
  }

  constructor(
    filterService: GridFilterService,
    private translateService: TranslateService) {
    super(filterService);
  }

  public onChange(value: unknown): void {
    this.applyFilter(
      value === null ?
        this.removeFilter(this.column) :
        this.updateFilter({
          field: this.column,
          operator: 'eq',
          value: value
        })
    );
  }
}
